import { BidAwardLockup } from '@tempmee/react';
import { Divider } from '~/commonComponents';
import { useBestInDentalWinnerCredential } from '~/hooks/useBestInDentalWinnerCredential';

/**
 * Best-in-Dental winner credential on the Account header, beside the office's
 * header card (hence the leading divider). Which office counts as a winner, and
 * from which source, is `useBestInDentalWinnerCredential`'s.
 */
export const BestInDentalWinner = () => {
  const { isWinner, year } = useBestInDentalWinnerCredential();

  if (!isWinner) {
    return null;
  }

  return (
    <>
      <Divider width={1} height="50%" />
      <BidAwardLockup
        elevated
        layout="split"
        label="Best in Dental"
        year={year}
        data-cy="bid-profile-winner"
      />
    </>
  );
};
